import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Link } from 'react-router';

const images = {
	finance1: require('@/assets/images/sub/img_function_bg_finance.png'),
	finance2: require('@/assets/images/sub/img_function_bg_finance2.png')
};

const financeSlides = [
	{ src: images.finance1, alt: '금융관리 이미지' },
	{ src: images.finance2, alt: '금융관리 이미지' }
];

const MainContentListBox = () => {
	return (
		<ul>
			{/* 경영보고서 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">경영보고서</strong>
							<p className="desc">
								경영에 꼭 필요한 모든 정보, 대시보드로 제공 <br />
								<span className="font-bold">빠르고 정확한 의사결정을 위한 스마트한 비즈니스 통찰</span>
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">매출, 매입 요약보고서 및 이익현황 제공</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">매출채권 및 매입채무에 대한 실시간 정보 제공</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">전 계좌잔액, 급여현황, 재고현황에 대해 요약 대시보드 제공</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
			{/* 기초정보 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title new">기초정보</strong>
							<p className="desc">
								데이터 수집에 필요한 <span className="font-bold">외부기관연동</span>과 <br />
								<span className="font-bold">고정자산, 전기자료</span> 등 기초가 되는 정보 입력
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">홈택스, 은행, 카드사, 국세청, 여신금융협회, 4대보험정보연계센터 연동</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">
										회사정보 및 거래처정보(신용정보관리), 고정자산 및 전기자료 등록 등 기초자료 입력 필요
									</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">사용자 등록 및 권한관리, 회계/급여 업무설정 기능 제공</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
			{/* 거래수집 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">거래수집</strong>
							<p className="desc">
								계좌입출금, 카드사용내역, 국세청 매입/매출 내역
								<br />
								<span className="font-bold">자동수집 및 자동전표처리</span>
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">외부기관 연동을 통해 각 기관별 적격 증빙내역 자동수집</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">계좌 거래 내역 실시간 조회 및 회계 전표 처리 연계</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">국세청 및 신용카드(매입/매출) 자료 실시간 조회 및 회계 전표 처리 연계</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
			{/* 회계관리 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title new">회계관리</strong>
							<p className="desc">
								경영데이터의 <span className="font-bold">자동분개</span>를 통한
								<br />
								간편한 <span className="font-bold">회계처리 및 경영상황</span>을 한 눈에 파악
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">초보자도 사용하기 쉬운 전표 처리방식 및 계정과목 추천 제공</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">팝업 혹은 그리드 전표입력방식 제공을 통한 사용자 편의성 강화</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">경영보고서 및 금융보고서 자동생성을 통한 의사결정 지원</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
			{/* 금융관리 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">금융관리</strong>
							<p className="desc">
								<span className="font-bold">자체 스크래핑 기술</span>을 통한 <br />
								실시간 계좌조회에서 이체까지 통합 <span className="font-bold">금융 관리</span>
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">전 은행 통합 계좌조회 및 일반이체, 대금이체, 급여이체 제공</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">회계전표, 급여대장 기반으로 이체정보 생성 및 실시간 이체 제공</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">집금이체 기능 제공을 통해 내부자금 관리 용이성 제공</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image">
								<Swiper
									modules={[Pagination]}
									spaceBetween={0}
									slidesPerView={1}
									pagination={{
										el: '.swiper-pagination',
										clickable: true
									}}
									observer={true}
									observeParents={true}>
									{financeSlides.map((slide, index) => (
										<SwiperSlide key={index}>
											<img src={slide.src} alt={slide.alt} />
										</SwiperSlide>
									))}
									<div className="swiper-pagination"></div>
								</Swiper>
							</div>
						</div>
					</div>
				</div>
			</li>
			{/* 인사급여 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">인사/급여</strong>
							<p className="desc">
								<span className="font-bold">사원관리, 4대보험신고, 급여관리</span>에서 <br />
								<span className="font-bold">퇴직금 관리, 원천세신고</span>까지 통합 제공
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">임직원 별 급여 내역 관리 및 회계 전표 자동 반영</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">정확한 급여 소득세 및 상여소득세 계산 제공</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">퇴직금 지급액 및 퇴직소득세 자동계산</span>
								</li>
								<li>
									<p className="num">04</p>
									<span className="desc">원천세 신고서 작성 시 급여데이터 자동수집 노출 및 전자신고 기능 제공</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
			{/* 재고관리 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<p className="title new">재고관리</p>
							<p className="desc">
								<span className="font-bold">입/출고 및 재고조정을 통한 수불부 관리</span>부터
								<br />
								<span className="font-bold">재고평가, 이익현황, 재고잔량 분석</span> 제공
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">
										거래처 전용품목, 거래등급별 단가 설정, 최근단가 선택을 통한 빠른 거래입력 가능
									</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">
										선입선출/이동평균법을 통한 재고평가, 품목별 이익현황, 발주/견적대비 입출고 현황제공
									</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">
										음수재고 통제여부, 전표입력 시 재고반영여부, 안전재고량 설정 등 다양한 옵션제공
									</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
							<div className="content-image mo"></div>
							<div className="content-image qr">
								<div className="btn-group">
									<Link
										to="https://apps.apple.com/kr/app/id6754354290"
										className="btn_apple"
										target="_blank"
										title="모바일재고관리 앱 app store 새창열기"></Link>
									<Link
										to="https://play.google.com/store/apps/details?id=com.finger.pharosapp"
										className="btn_google"
										target="_blank"
										title="모바일 재고관리 앱 google store 새창열기"></Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</li>
			{/* 영업관리 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">영업관리</strong>
							<p className="desc">
								<span className="font-bold">견적서, 수주서 입력, 발송 및 출고처리 연동</span>으로
								<br />
								체계적인 견적/수주 관리 가능
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">견적서, 수주서를 작성하고 거래처에 전자문서로 발송 가능</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">견적서, 수주서 기반으로 출고처리 연동</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">견적대비 출고내역, 수주대비 출고내역을 통한 정확한 출고관리</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
			{/* B2B */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title new">B2B 수발주</strong>
							<p className="desc">
								가장 간편한 기업 간 거래를 위한 B2B 수발주 서비스
								<br />
								<span className="font-bold">견적, 발주, 결제까지 모든 절차를 손쉽게 처리</span>
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">
										[품목 및 거래처 연동] 스텔라에 등록된 품목 및 거래처를 B2B 수발주 플랫폼에 자동 연동, 엑셀 업로드를
										통한 상품 상세 정보 일괄 등록까지 지원
									</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">
										[수주 및 출고 처리 연동] 거래처 발주에 대해 수주 확정, 출고 처리 및 회계 처리까지 연속적인 업무처리
										지원
									</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">
										[가상계좌 서비스 및 결제관리] 거래처별 맞춤형 결제 방식 지원, 대금청구서 작성 및 발송 기능 제공
									</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
							<div className="content-image mo"></div>
						</div>
					</div>
					<div className="content-info"></div>
				</div>
			</li>
			{/* 장부/결산 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title new">장부/결산</strong>
							<p className="desc">
								전문적인 회계지식 없이도
								<br />
								<span className="font-bold">결산전표 자동 분개처리 및 장부생성, 결산 가능</span>
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">매입/매출/현금 등 다양한 거래에 대한 자동 장부작성 및 결산전표 자동분개</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">일일거래기록(일계표) 및 월계표, 시산표 등 자동 생성</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">
										기업회계기준 및 세법에 따른 결산업무 수행, 다양한 보조원장 및 결산재무재표 제공
									</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
			{/* 세금신고 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">세금신고</strong>
							<p className="desc">
								클릭 한번으로 <span className="font-bold">부가세 신고서 작성</span> 및 <br />
								파일생성, <span className="font-bold">원천세 신고</span>를 위한{' '}
								<span className="font-bold">서류 자동생성 기능</span> 제공
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">정확한 신고서 작성을 위해 회계전표 내역과 홈택스 자료 대사 기능 제공</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">부가세 신고서를 전자파일로 변환하여 홈택스에 직접 신고 가능</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">원천징수이행상황신고서와 간이지급명세서 간편하게 작성</span>
								</li>
								<li>
									<p className="num">04</p>
									<span className="desc">세법 및 관련법규 변경 시 빠른 업데이트 지원</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
			{/* 제증명발급 */}
			<li className="content-list">
				<div className="content-box">
					<div className="content-text">
						<div className="content-title">
							<strong className="title">제증명발급</strong>
							<p className="desc">
								기업 운영에 필요한 <br />
								<span className="font-bold">각종 민원문서발급을 사이트 접속 없이 즉시 발급</span>
							</p>
						</div>
						<div className="content-desc">
							<ul>
								<li>
									<p className="num">01</p>
									<span className="desc">업계최다, 기업 업무에 필요한 제증명 서류 발급 자동화</span>
								</li>
								<li>
									<p className="num">02</p>
									<span className="desc">홈택스, 대법원, 정부24 접속없이 원클릭 서류발급</span>
								</li>
								<li>
									<p className="num">03</p>
									<span className="desc">신청문서 다운로드 폴더에 저장 및 저장된 문서로 출력 가능</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="content-bg">
						<div className="content-frame">
							<div className="content-image"></div>
						</div>
					</div>
				</div>
			</li>
		</ul>
	);
};

export default MainContentListBox;
